import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr';
import en from './locales/en';

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			fr: { translation: fr },
			en: { translation: en },
		},
		supportedLngs: ['fr', 'en'],
		nonExplicitSupportedLngs: true,
		fallbackLng: 'en',
		interpolation: { escapeValue: false },
		detection: {
			order: ['localStorage', 'navigator'],
			caches: ['localStorage'],
		},
	});

export default i18n;
